import { connect } from 'react-redux';
import Approval from '../../../views/Personnel/Absensi/Approval.absensi.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}

export default connect(null, mapDispatchToProps)(Approval);